import Pie from './img-video/PIE.png';

export const Formulario = () => {

	return (
		<>
			<section id="contact" class="contact">
                <div className='script-formulario'>
                    <script data-b24-form="inline/159/3gp42n" data-skip-moving="true">
                        {(function(w,d,u){
                        var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
                        var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
                        })(window,document,'https://cdn.bitrix24.eu/b15201739/crm/form/loader_159.js')}
                    </script>
                </div>
                <div className="container-img">
                    <img className="img-form" src={Pie}></img>
                </div>
            </section>
		</>
	);
};
